import { render, staticRenderFns } from "./AnnouncementRibbon.vue?vue&type=template&id=4c321202&"
import script from "./AnnouncementRibbon.ts?vue&type=script&lang=ts&"
export * from "./AnnouncementRibbon.ts?vue&type=script&lang=ts&"
import style0 from "./AnnouncementRibbon.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports